import { authHeader } from 'services';
import { IEvaluationFilter, IEvaluationResult } from 'types/Evaluation';

import { Api } from './api/axios.service';

const BASE_URL = '/treatment-history';

/**
 * Find all evaluations and search by name vet and date treatment
 *
 * @param {IEvaluationFilter} {
 *   page = 1,
 *   limit = 10,
 *   vetName,
 *   startDate,
 *   endDate,
 * }
 * @return {*}  {Promise<IEvaluationResult>}
 */
const findAllEvaluations = async ({
  page = 1,
  limit = 10,
  vetName,
  startDate,
  endDate,
}: IEvaluationFilter): Promise<IEvaluationResult> => {
  if (startDate) {
    startDate = new Date(startDate).toISOString();
  } else {
    startDate = '';
  }
  if (endDate) {
    endDate = new Date(endDate).toISOString();
  } else {
    endDate = '';
  }

  try {
    const { data } = await Api.get(
      `${BASE_URL}/getAllEvaluations?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&vetName=${vetName}`,
      {
        headers: authHeader(),
      }
    );

    return data;
  } catch (reason) {
    const { message } = reason as Error;

    throw new Error(message || 'Não foi possível listar as avaliações');
  }
};

export const EvaluationService = {
  findAllEvaluations,
};
